export enum OmEmeaSubmissionChannel {
    MDLA = 'MDLA',
    WEBSHOP = 'WEBSHOP',
    EMAIL = 'EMAIL'
}
